// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"baseUserForm_deleteButton__2ukh9"};